module.exports = __webpack_public_path__ + "img/1f34b.c6ec63a.svg";